module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "basic-box cabinet__basic-box"
  }, [_c('div', {
    staticClass: "basic-box__title"
  }, [_vm._v("Запросы на подтверждение")]), _vm._v(" "), _vm._l((_vm.value), function(event) {
    return _c('notification-item', {
      key: event._id,
      attrs: {
        "event": event
      }
    })
  }), _vm._v(" "), (!_vm.value.length) ? _c('div', [_vm._v("У Вас еще не было запросов")]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6905f9ad"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Notification.vue
// module id = 622
// module chunks = 0